import React from "react";
import styled from "styled-components";
import { Link, useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

//
import IconWrapper from "../../../components/icon-wrapper/IconWrapper";
import LOGOIMG from "../../../assets/images/logo.png";
import Button from "../../../components/button/Button";
import ImageOverlayCard from "../../../components/image-overlay-card/ImageOverlayCard";

export default function SingleServiceTop({ service }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  function handleNavigate(url) {
    navigate(url);
  }

  return (
    <StyledSingleServiceTop>
      <div className="container">
        <div className="single-service-top__wrap">
          <div className="single-service-top__left">
            <ImageOverlayCard
              className="single-service-top__img"
              image={service.img}
              title={t(service.title)}
              alt={t(service.title)}
            />
            <h1>What is Glaucoma?</h1>
            <p>
              Laoreet non curabitur gravida arcu. Dictumst quisque sagittis
              purus sit amet. Ultrices dui sapien eget mi proin sed. Molestie at
              elementum eu facilisis sed odio morbi quis commodo. Pharetra magna
              ac placerat vestibulum lectus mauris. Sem nulla pharetra diam sit
              amet. Rhoncus urna neque viverra justo nec ultrices dui sapien
              eget. Nunc congue nisi vitae suscipit tellus mauris
            </p>
            <div className="single-service-top__list">
              <h1>Symptoms of Glaucoma</h1>
              <ul>
                <li>
                  <IconWrapper
                    w={18}
                    h={18}
                    icon="check"
                    iconW={14}
                    iconH={14}
                  />
                  <p>
                    Loss of peripheral or side vision (this is usually the first
                    sign of glaucoma)
                  </p>
                </li>
                <li>
                  <IconWrapper
                    w={18}
                    h={18}
                    icon="check"
                    iconW={14}
                    iconH={14}
                  />
                  <p>Eye redness</p>
                </li>
                <li>
                  <IconWrapper
                    w={18}
                    h={18}
                    icon="check"
                    iconW={14}
                    iconH={14}
                  />
                  <p>Increased sensitivity to lights</p>
                </li>
                <li>
                  <IconWrapper
                    w={18}
                    h={18}
                    icon="check"
                    iconW={14}
                    iconH={14}
                  />
                  <p>
                    Appearance of halos (rainbow-coloured) around bright lights
                  </p>
                </li>
                <li>
                  <IconWrapper
                    w={18}
                    h={18}
                    icon="check"
                    iconW={14}
                    iconH={14}
                  />
                  <p>Blurry or foggy vision</p>
                </li>
                <li>
                  <IconWrapper
                    w={18}
                    h={18}
                    icon="check"
                    iconW={14}
                    iconH={14}
                  />
                  <p>Nausea and vomiting (accompanying severe eye pain)</p>
                </li>
              </ul>
            </div>
          </div>
          <div className="single-service-top__right">
            <div className="single-service-top__logo-card">
              <img src={LOGOIMG} alt="LOGOIMG" width="84" />
              <h1>Consultation on the Cornea and Glaucoma</h1>
              <Button
                fill={true}
                hover="white"
                onClick={() => handleNavigate("/contact")}
              >
                Make an Appointment
              </Button>
            </div>
            <div className="single-service-top__other-service">
              <h1>Other Services</h1>
              <ul>
                <li>
                  <Link to="/service/all">
                    <i className="icon icon-contact-lens"></i>
                    <p>Strabismus Treatment</p>
                  </Link>
                </li>
                <li>
                  <Link to="/service/all">
                    <i className="icon icon-urgent-vision"></i>
                    <p>Keratoconus</p>
                  </Link>
                </li>
                <li>
                  <Link to="/service/all">
                    <i className="icon icon-ocular-care"></i>
                    <p>Refractive Lensectomy</p>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </StyledSingleServiceTop>
  );
}

const StyledSingleServiceTop = styled.section`
  padding: 140px 0;
  background-color: var(--white);

  .single-service-top {
    &__wrap {
      display: grid;
      grid-template-columns: 65fr 31fr;
      gap: 40px;
    }

    &__left {
      h1 {
        color: var(--title);
        font-size: var(--fs-card-title);
        font-style: normal;
        font-weight: var(--fw-semibold);
        line-height: 1.35;
        margin-bottom: 24px;
      }

      & > p {
        color: var(--text);
        font-size: var(--fs-body);
        font-style: normal;
        font-weight: var(--fw-regular);
        line-height: var(--lh-body);
        text-align: left;
        margin-bottom: 48px;
      }

      ul {
        display: flex;
        flex-direction: column;
        gap: 24px;

        li {
          display: flex;
          gap: 12px;
          align-items: center;

          p {
            color: var(--title);
            font-size: var(--fs-body-sm);
            font-style: normal;
            font-weight: var(--fw-medium);
            line-height: var(--lh-body);
          }
        }
      }
    }

    &__img {
      width: 100%;
      max-height: 350px;
      line-height: 0;
      overflow: hidden;
      margin-bottom: 48px;
      border: 1px solid var(--border);
    }

    &__right {
    }

    &__logo-card {
      background-color: var(--dark-blue);
      padding: 40px;
      margin-bottom: 64px;

      h1 {
        color: var(--white);
        font-size: var(--fs-card-title);
        font-style: normal;
        font-weight: var(--fw-semibold);
        line-height: 1.35;
        margin-top: 4px;
        margin-bottom: 32px;
      }
    }

    &__other-service {
      h1 {
        color: var(--title);
        font-size: var(--fs-card-title);
        font-style: normal;
        font-weight: var(--fw-semibold);
        line-height: 1.35;
        margin-bottom: 32px;
      }

      ul {
        display: flex;
        flex-direction: column;
        gap: 32px;

        li {
          a {
            background-color: var(--bg);
            border: 1px solid var(--border);
            padding: 32px;
            display: flex;
            align-items: center;
            gap: 24px;
            transition: 0.4s ease;

            i {
              width: 40px;
              height: 40px;
              background-color: var(--light-blue);
            }

            p {
              color: var(--title);
              font-size: var(--fs-body);
              font-style: normal;
              font-weight: var(--fw-medium);
              line-height: var(--lh-body);
            }

            &:hover {
              border-color: var(--light-blue);
            }
          }
        }
      }
    }
  }
`;
